import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/home.css";
import { FaShoppingCart, FaBars, FaTimes, FaSignOutAlt } from "react-icons/fa";
import { useCart } from "../contexts/CartContext";
import { useAuth } from "../contexts/AuthContext";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { getCartCount } = useCart();
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      setMenuOpen(false);
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  return (
    <nav className="navbar">
      <div className="nav-logo">
        <Link to="/" onClick={() => setMenuOpen(false)}>M&L</Link>
      </div>

      <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        </li>

        {currentUser && (
          <li>
            <Link to="/profile" onClick={() => setMenuOpen(false)}>Profile</Link>
          </li>
        )}

        <li>
          <Link to="/shop" onClick={() => setMenuOpen(false)}>Shop</Link>
        </li>

        <li>
          <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
        </li>

        {!currentUser && (
          <>
            <li>
              <Link to="/login" onClick={() => setMenuOpen(false)}>Login</Link>
            </li>
            <li>
              <Link to="/signup" onClick={() => setMenuOpen(false)}>Sign Up</Link>
            </li>
          </>
        )}
      </ul>

      <div className="nav-right">
        <Link to="/cart" className="nav-cart-link" onClick={() => setMenuOpen(false)}>
          <div className="nav-cart">
            <FaShoppingCart size={20} />
            <span className="cart-count">{getCartCount()}</span>
          </div>
        </Link>

        {currentUser && (
          <button 
            className="nav-logout-btn" 
            onClick={handleLogout}
            title="Logout"
          >
            <FaSignOutAlt size={18} />
          </button>
        )}

        <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;